import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { routes } from '@/constant/routes.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { AirportNonRefundableMessage } from '@repo/components';
import { Button } from '@successmode-ktp/kui';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ICON_ARROW_LEFT } from '@repo/assets';
import { IGlobalState } from '@/store';

const MedicalAirportNonRefundable = () => {
  const history = useHistory();

  const { departureDate, nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  // TODO: 키오스크 없는 공항(그 외) -> 출국일 입력 또는 홈
  const onNext = () => {
    if (departureDate) {
      history.push({
        pathname: routes.medicalHome,
      });
    } else {
      history.push({
        pathname: routes.medicalDeparture,
      });
    }
  };

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    next: ['Get Refund to bank account', '은행 계좌로 환급받기'],
  };

  return (
    <ReceiptLayout>
      <Content>
        <BackButton
          onClick={() => {
            passportNumber && localStorage.removeItem(passportNumber);
            history.goBack();
          }}
        >
          <img src={ICON_ARROW_LEFT} alt='뒤로 가기' width={24} />
        </BackButton>
        <AirportNonRefundableMessage nationality={nationality} />
      </Content>
      <Footer>
        <Button
          style={{
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          }}
          size='lg'
          onClick={onNext}
        >
          {text.next[nationIndex]}
        </Button>
      </Footer>
    </ReceiptLayout>
  );
};

const BackButton = styled.button`
  width: 24px;
  height: 24px;
  margin-top: 20px;
`;

const Content = styled.div`
  width: 100%;
  min-height: calc(
    100dvh - 90px- 52px - 36px - 8px
  ); // padding-top, footer button height, footer margin-bottom, gap
  height: 100%;
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px 20px 36px 20px;
  box-shadow: 0px -4px 8px 0px rgba(106, 106, 106, 0.25);
  background-color: #fff;
`;

export default MedicalAirportNonRefundable;
